import { ApolloError, ApolloQueryResult } from '@apollo/client';
import {
  FindShipmentQuery,
  SidekickSupportedTms,
  useFindShipmentQuery,
} from '@shared/generated/graphql';

type UseFindShipmentProps = {
  organizationId: string;
} & (
  | { referenceNumber: string; tms?: SidekickSupportedTms }
  | { shipmentId: string }
);

export type FindShipmentResult = {
  shipmentId?: string;
  isLoading: boolean;
  error?: ApolloError;
  refetch: () => Promise<ApolloQueryResult<FindShipmentQuery>>;
};

export function useFindShipment(
  props: UseFindShipmentProps
): FindShipmentResult {
  const variables = { input: props };
  const result = useFindShipmentQuery({ variables });
  const { data, loading, error, refetch } = result;
  return {
    shipmentId: data?.findShipment?.shipmentId,
    isLoading: loading,
    error,
    refetch,
  };
}
